module.exports = __webpack_public_path__ + "media/images/icons/print_share-2e6d720510f6beb0065779d537409918.svg";